import React, { useEffect, useMemo } from 'react'
import { JourneyLevel, JourneyMapComponent } from '@labrav/react-components'
import paperplane from '../../../../common/images/paper-plane-top.svg'
import check from '../../../../common/images/badge-check-sharp-regular.svg'
import clipboard from '../../../../common/images/clipboard-check.svg'
import hourglass from '../../../../common/images/hourglass-start-light.svg'
import file from '../../../../common/images/file-signature-light.svg'
import octagon from '../../../../common/images/octagon-exclamation-regular.svg'
import { transformApiDataToJourneySteps } from '../../../../common/utils/transformApiDataToJourneySteps'
import { useDispatch, useSelector } from '../../../../store/hooks'
import { useParams } from 'react-router-dom'
import { getBuyersJourneyData } from '../../../../modules/buyers/action'
import { LoadingTypes, isLoading, useAccountId } from '@labrav/common'
import {
  ContractType,
  JourneyContractDetails,
} from '../../../../modules/buyers/types'
import { LoadingJourneyComponent } from '../BuyerJourneyMap'

export const iconMap: Record<string, { icon: JSX.Element; label: string }> = {
  offerSent: {
    icon: <img src={paperplane} alt="" />,
    label: 'Offer sent',
  },
  offerAccepted: {
    icon: <img src={check} alt="" />,
    label: 'Offer accepted',
  },
  contractRenewal: {
    icon: <img src={file} alt="" />,
    label: 'Contract renewal',
  },
  contractStarted: {
    icon: <img src={hourglass} alt="" />,
    label: 'Contract started',
  },
  contractEnded: {
    icon: <img src={clipboard} alt="" />,
    label: 'Contract ended',
  },
  offerAboSent: {
    icon: <img src={paperplane} alt="" />,
    label: 'ABO sent',
  },
  offerAboAccepted: {
    icon: <img src={check} alt="" />,
    label: 'ABO accepted',
  },
  contractUnsubscribed: {
    icon: <img src={octagon} alt="" />,
    label: 'Contract unsubscribe',
  },
  offerExpired: {
    icon: <img src={octagon} alt="" />,
    label: 'Offer expired',
  },
  offerRestricted: {
    icon: <img src={octagon} alt="" />,
    label: 'Offer cancelled',
  },
}

export const JourneyMapComponentItem: React.FC<{
  contractId: string
  contractType: ContractType
}> = ({ contractId, contractType }) => {
  const dispatch = useDispatch()
  const accountId = useAccountId({ product: 'flyout' }) || ''
  const { buyerId } = useParams()

  const isLoadingState = useSelector<boolean>(state =>
    isLoading(state.loading)(LoadingTypes.BUYER_JOURNEY)
  )

  const buyerContractsDetails = useSelector<JourneyContractDetails>(
    state => state.BuyersOverView.buyerJourney
  )
  const contractStates = useMemo(() => {
    return (
      buyerContractsDetails?.states?.map(({ contractId, ...rest }) => ({
        states: (rest.states ? rest.states : rest) as unknown as Record<
          string,
          string
        >,
      })) ?? []
    )
  }, [buyerContractsDetails])

  const publicSubcribeMap = {
    icon: <img src={check} alt="" />,
    label: 'Contract subscribed',
  }
  const updatedIconMap = {
    ...iconMap,
    contractStarted:
      contractType === 'PUBLIC' ? publicSubcribeMap : iconMap.contractStarted,
  }
  const buyerContractsJourney: JourneyLevel[] = useMemo(() => {
    if (contractStates) {
      return transformApiDataToJourneySteps(contractStates, updatedIconMap)
    }
    return []
  }, [contractStates, updatedIconMap])

  useEffect(() => {
    if (accountId && buyerId && contractId && contractType) {
      dispatch(
        getBuyersJourneyData({
          partnerId: accountId,
          labraBuyerDetailsId: buyerId,
          contractId,
          contractType,
        })
      )
    }
  }, [accountId, buyerId, contractId, contractType, dispatch])

  return (
    <>
      {isLoadingState ? (
        <LoadingJourneyComponent />
      ) : (
        <div data-testid="buyer-journey-map">
          {buyerContractsJourney && (
            <JourneyMapComponent levelsData={buyerContractsJourney} />
          )}
        </div>
      )}
    </>
  )
}
